<div class="dealer" [class.selfdealer]="slefPlayerDealer" [style.left]="dealer.position.getXAxis()" [style.top]="dealer.position.getYAxis()"></div>
